import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/api/config/query-keys";
import { apiClient } from "@/api/config/api-client";
import { API_ENDPOINTS } from "@/api/config/api-endpoints";
import type { LLMModelsResponse } from "@/api/models/api-types";

export const useLLMPrefetch = () => {
  const queryClient = useQueryClient();

  const prefetchLLMModels = useCallback(async () => {
    // LLM models zaten cache'de varsa prefetch yapma
    const cachedData = queryClient.getQueryData([
      ...QueryKeys.CONVERSATIONS.all,
      "llm-models",
      { provider_type: "llm", limit: 20, searchTerm: "" },
    ]);

    if (cachedData) {
      return; // Zaten cache'de var
    }

    // Background'da prefetch yap
    queryClient.prefetchInfiniteQuery({
      queryKey: [
        ...QueryKeys.CONVERSATIONS.all,
        "llm-models",
        { provider_type: "llm", limit: 20, searchTerm: "" },
      ],
      queryFn: async ({ pageParam = 1 }): Promise<LLMModelsResponse> => {
        const searchParams = new URLSearchParams({
          page: String(pageParam),
          limit: String(20),
          provider_type: "llm",
        });
        const response = await apiClient.get<LLMModelsResponse>(
          `${API_ENDPOINTS.getAllLLMModels}?${searchParams.toString()}`
        );
        return response;
      },
      initialPageParam: 1,
      getNextPageParam: (lastPage: LLMModelsResponse) => {
        const { page, totalPage } = lastPage.data.meta;
        const nextPage = page + 1;
        return nextPage <= totalPage ? nextPage : undefined;
      },
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    });
  }, [queryClient]);

  return {
    prefetchLLMModels,
  };
};
